$(function () {
  $(".shopify-section--main-article .rte a").each(function(){
    var articleHref = $(this).attr("href").split('/')[2];
    if(articleHref != window.location.host){
      $(this).attr("rel","nofollow");
    };
  });
});

$(document).ready(function() {
  if($(".article__author").length != 0){
    let article_author_text = $(".article__author").text();
    console.log(article_author_text);
    if(article_author_text == 'By Lisa Wang' || article_author_text == 'By Amelia Brown' || article_author_text == 'By BrownAmelia' || article_author_text == 'By MikeBrown' ){
      $('.article__content .rte').find('ul').eq(0).empty();
      $('.article__content .rte h2').each(function(index) {
        $(this).attr('id', 'section-' + (index+1));
    
        var link = $('<a>').attr('href', '#section-' + (index+1)).text($(this).text());
    
        var listItem = $('<li>').append(link);
        $('.article__content .rte').find('ul').eq(0).append(listItem);
    
        link.click(function(e) {
          e.preventDefault();
          var target = $(this.hash);
          $('html, body').animate({
            scrollTop: target.offset().top - 100
          }, 1000);
        });
      });
    }
  }
});

$(document).ready(function() {
  const keywords = [
    'pearl necklace', 
    'luxury jewelry', 
    'layering necklaces', 
    'earrings', 
    'jewelry trends'
  ];
  $('.article__main-part .article__content a').each(function() {
    const $link = $(this);
    const linkText = $link.text().toLowerCase().trim();
    const isMatch = keywords.some(word => linkText.includes(word.toLowerCase()));
    if (isMatch) {
      $link.attr('rel', 'dofollow');
      
      $link.attr('rel', function(i, val) {
        return val ? val.replace('nofollow', '').trim() : 'dofollow';
      });
    }
  });
});